module.exports = __webpack_public_path__ + "static/media/hoc-phong-thuy-tuong-minh_1.571810b4.jpg";